/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type { IrremovableField } from '@atlassian/jira-jql-builder-basic/src/utils/irremovable-fields/index.tsx';

export const createdField = {
	displayName: 'Created',
	fieldType: 'created',
	jqlTerm: 'created',
	operators: [
		'LESS_THAN_OR_EQUAL',
		'GREATER_THAN_OR_EQUAL',
		'NOT_IN',
		'IS_NOT',
		'LESS_THAN',
		'GREATER_THAN',
		'EQUALS',
		'IS',
		'IN',
		'NOT_EQUALS',
	],
	searchTemplate: 'created',
	type: 'created',
} as unknown as IrremovableField;

export const priorityField = {
	displayName: 'Priority',
	fieldType: 'priority',
	jqlTerm: 'priority',
	operators: [
		'GREATER_THAN_OR_EQUAL',
		'LESS_THAN',
		'GREATER_THAN',
		'WAS_NOT',
		'IS',
		'IN',
		'CHANGED',
		'LESS_THAN_OR_EQUAL',
		'NOT_IN',
		'IS_NOT',
		'WAS_NOT_IN',
		'EQUALS',
		'WAS_IN',
		'WAS',
		'NOT_EQUALS',
	],
	searchTemplate: 'priority',
	type: 'priority',
} as unknown as IrremovableField;
